var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIotx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#00D4D5"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.519 5v5.457l4.738-2.725z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M21.257 7.732v5.457l4.737-2.732z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M16.519 10.457v5.457l4.738-2.725zm4.738 2.733v5.456l4.737-2.732z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M16.519 15.914v5.457l4.738-2.725z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.257 18.646v5.457l4.737-2.732z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M4.273 10.273v5.457l4.738-2.732z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.25 12.302v5.457l4.73-2.725z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M6.738 15.753v5.457l4.737-2.732z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M9.86 19.871v5.457l4.73-2.732z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M16.48 22.22v5.458l4.73-2.733z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M11.039 9.607v5.458l4.73-2.725z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M16.519 5v5.457l-4.738-2.725z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M11.039 7.32v5.456L6.3 10.044z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M15.777 10.02v5.458l-4.738-2.733z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M10.228 12.302v5.457L5.49 15.034z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M16.519 15.914v5.457l-4.73-2.725z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M6.738 17.185v5.457L2 19.909z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.994 10.457v5.457l-4.737-2.725z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M21.257 13.19v5.456l-4.738-2.732z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M25.994 15.914v5.457l-4.737-2.725z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M21.257 18.646v5.457l-4.738-2.732z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.47 20.92v5.457l-4.737-2.725z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.257 7.732v5.457l-4.738-2.732z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIotx);
export default __webpack_public_path__ + "static/media/iotx.804ed46a8e4161d7afff8133881226cf.svg";
export { ForwardRef as ReactComponent };